<template>
    <div>
        <content-with-side-menu>
            <template #side-menu>
                <mq-layout mq="tablet+">
                    <explorer-folder-menu :folders="folders" />
                </mq-layout>
            </template>
            <template #main-content>
                <mq-layout mq="mobile"></mq-layout>
                <div class="section">
                    <app-search-bar-with-filter
                        v-model="searchText"
                        :filter.sync="filter"
                    />
                    <explorer-filter-bar
                        :filters="selectedFolders"
                        @removeFilter="removeSelectedFolder"
                    />
                    <div v-if="searchText.length || selectedFolders.length">
                        <transition-group
                            v-if="loading && !filteredProjects.length"
                            mode="out-in"
                            name="lb-project-list"
                            tag="div"
                            class="columns is-multiline is-mobile mx-0"
                            appear
                        >
                            <div
                                v-for="i in 20"
                                :key="i"
                                class="
                                    column
                                    is-12-mobile is-6-tablet is-4-widescreen
                                "
                            >
                                <div class="lb-project-box is-loading"></div>
                            </div>
                        </transition-group>
                        <projects-grid
                            v-if="filteredProjects.length"
                            :projects="filteredProjects"
                        />
                        <p
                            v-else-if="!loading"
                            v-t="'App.search_empty_results'"
                            class="notification is-info"
                        ></p>
                    </div>

                    <explorer-folder-section
                        v-for="folder in filteredFolders"
                        v-else
                        :key="folder._id"
                        :filter="filter"
                        v-bind="folder"
                        :selected.sync="folder.selected"
                        @click="selectProject"
                    />
                </div>
            </template>
        </content-with-side-menu>
        <project-modal-resume
            v-if="showModal"
            :project-source="project"
            @close="showModal = false"
            @share="showShareModal = true"
        />
        <project-modal-share
            v-if="showShareModal"
            :content="project"
            @close="showShareModal = false"
        />
    </div>
</template>

<script>
import ExplorerFolderMenu from '@/components/ExplorerFolderMenu';
import AppSearchBarWithFilter from '@/components/AppSearchBarWithFilter';
import ExplorerFolderSection from '@/components/ExplorerFolderSection';
import ExplorerFilterBar from '@/components/ExplorerFilterBar';
import ProjectModalResume from '@/components/ProjectModalResume';
import ProjectModalShare from '@/components/ProjectModalShare';
import ProjectsGrid from '@/components/ProjectsGrid';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
import { fetchItems, fetchPublicFolders } from '@/services/API';
import { Document } from 'flexsearch';
import _ from 'underscore';
export default {
    components: {
        ExplorerFilterBar,
        ExplorerFolderMenu,
        AppSearchBarWithFilter,
        ExplorerFolderSection,
        ProjectsGrid,
        ProjectModalResume,
        ProjectModalShare,
        ContentWithSideMenu,
    },
    data() {
        return {
            searchText: '',
            folders: [],
            publicProjects: [],
            filter: this.$t('Constants.FILTER_OPTION_PROJECTS_ALL'),
            loading: false,
            filters: [],
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        'title',
                        'description',
                        'tags',
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            showModal: false,
            showShareModal: false,
            project: null,
        };
    },
    computed: {
        filteredFolders() {
            const folders = JSON.parse(JSON.stringify(this.folders));
            switch (this.filter) {
                case this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS'):
                    return _.map(folders, (folder) => {
                        folder.projects = _.filter(
                            folder.projects,
                            (project) => {
                                return project.type == 'collection';
                            }
                        );
                        return folder;
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES'):
                    return _.map(folders, (folder) => {
                        folder.projects = _.filter(
                            folder.projects,
                            (project) => {
                                return project.type != 'collection';
                            }
                        );
                        return folder;
                    });
                    break;
                default:
                    return this.folders;
                    break;
            }
        },
        filteredProjects() {
            if (this.searchText.length) {
                return this.publicFilteredProjects;
            }
            let folders = this.folders;
            if (this.selectedFolders.length) {
                folders = this.selectedFolders;
            }
            let projects = _.chain(folders).pluck('projects').flatten().value();
            switch (this.filter) {
                case this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS'):
                    projects = _.filter(projects, (project) => {
                        return project.type == 'collection';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES'):
                    projects = _.filter(projects, (project) => {
                        return project.type != 'collection';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_ALL'):
                    return projects;
                    break;
                default:
                    return this.publicFilteredProjects;
                    break;
            }
            return projects;
        },
        publicFilteredProjects() {
            this.rebuildIndex();
            this.publicProjects.forEach((item) => {
                this.searchIndex.add(item);
            });
            const result = this.searchIndex.search(this.searchText);
            const ids = _.chain(result).pluck('result').flatten().value();
            return this.publicProjects.filter((item) => {
                return _.contains(ids, item._id);
            });
        },
        type() {
            if (
                this.filter == this.$t('Constants.FILTER_OPTION_PROJECTS_ALL')
            ) {
                return undefined;
            }
            return this.filter ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
                ? 'collection'
                : 'trivial,treasurehunt';
        },
        selectedFolders() {
            return this.folders.filter((folder) => folder.selected);
        },
    },
    watch: {
        searchText: 'searchProjects',
        filter: 'searchProjects',
    },
    mounted() {
        fetchPublicFolders().then((e) => {
            this.folders = e.data;
        });
        //this.searchProjects();
    },
    methods: {
        selectProject(project) {
            this.showModal = true;
            this.project = project;
        },
        async searchProjects() {
            this.rebuildIndex();
            this.loading = true;
            let projects = await fetchItems(`project/explore`, {
                title_contains: this.searchText,
                description_contains: this.searchText,
                owner_contains: this.searchText,
                type_in: this.type,
            }).finally(() => {
                this.loading = false;
            });
            this.publicProjects = projects.data;
        },
        rebuildIndex() {
            let folders = this.folders;
            if (this.selectedFolders.length) {
                folders = this.selectedFolders;
            }
            let projects = _.chain(folders).pluck('projects').flatten().value();
            this.searchIndex.remove(projects);
            /*this.searchIndex.destroy();
            this.searchIndex.init({
                document: {
                    id: '_id',
                    index: [
                        'title',
                        'description',
                        'tags',
                        'owner:name',
                        'owner:email',
                    ],
                },
            });*/
        },
        removeSelectedFolder(folder) {
            _.find(this.folders, folder).selected = false;
        },
    },
};
</script>

<style></style>
